<template>
  <v-main>
    <div id="scroll-container" @click="displaybeta">
      <div id="scroll-text">{{ beta }}</div>
    </div>
    <v-card flat>
      <v-toolbar :color="barcolor" dark dense flat class="mb-1">
        
        <v-toolbar-title class="text-h5"  v-text="name" />
        <v-progress-linear
          :active="titleloading"
          :indeterminate="titleloading"
          absolute
          bottom
          color="yellow accent-4"
        ></v-progress-linear>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-container
        class="container1"
        fluid
        fill-height
        v-if="$route.path === 'Login'"
      >
        <router-view :key="$route.path" />
      </v-container>
      <v-container class="container1" fluid v-if="$route.path != 'Login'">
        <router-view :key="$route.path" />
      </v-container>
    </v-card>
    <v-dialog v-model="dialogConfirmLocal" max-width="600">
      <v-card>
        <v-toolbar dense color="secondary" dark>Beta Version</v-toolbar>
        <div class="center">
          <p class="text-h6">{{ beta }}</p>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogConfirmLocal = false"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-main>
</template>
<style scoped>
#scroll-container {
  overflow: hidden;
  cursor: pointer;
}

#scroll-text {
  /* animation properties */
  -moz-transform: translateX(100%);
  -webkit-transform: translateX(100%);
  transform: translateX(100%);

  -moz-animation: my-animation 35s linear infinite;
  -webkit-animation: my-animation 35s linear infinite;
  animation: my-animation 35s linear infinite;
}

/* for Firefox */
@-moz-keyframes my-animation {
  from {
    -moz-transform: translateX(100%);
  }
  to {
    -moz-transform: translateX(-100%);
  }
}

/* for Chrome */
@-webkit-keyframes my-animation {
  from {
    -webkit-transform: translateX(100%);
  }
  to {
    -webkit-transform: translateX(-100%);
  }
}

@keyframes my-animation {
  from {
    -moz-transform: translateX(100%);
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
  }
  to {
    -moz-transform: translateX(-100%);
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
  }
}
.container1 {
  padding: 0px;
}

.center {
  margin-top: 2em;
  text-align: center;
}
</style>

<script>
import { get } from "vuex-pathify";
export default {
  name: "DefaultView",
  data: () => ({
    barcolor: "primary",
    loading: true,
    dialogConfirmLocal: false,
  }),
  computed: {
    name: get("route/name"),
    isReverse: get("app/isReverse"),
    beta: get("app/beta"),
    titleloading: get("app/titleloading"),
  },
  watch: {
    isReverse: function(value) {
      if (value) this.barcolor = "warning";
      else this.barcolor = "primary";
    },
  },
  methods: {
    displaybeta() {
      this.dialogConfirmLocal = true;
    },
  },
};
</script>
